import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { InputTextWebElement } from './InputTextWebElement';
export { InputTextWebElement };

/**
 * Retrieve an instance of [InputTextWebElement](../classes/InputTextWebElement.html).
 * @example
 * ```javascript
 * import { findInputText } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findInputText(driver, By.id('my-oj-c-input-text'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findInputText(driver: DriverLike, by: By): Promise<InputTextWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type InputTextWebElement
  if (!(webEl instanceof InputTextWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'InputTextWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findInputText(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${InputTextWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-input-text', InputTextWebElement);
